export const gitVersion="1.1.1-1-g19cbaee";
